import { render, staticRenderFns } from "./ContactModuleRulesEnabled.vue?vue&type=template&id=28902b06&scoped=true"
import script from "./ContactModuleRulesEnabled.vue?vue&type=script&lang=js"
export * from "./ContactModuleRulesEnabled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28902b06",
  null
  
)

export default component.exports